import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { colours } from './playerStyles'

// Back / Next. Next stays in the tab order while locked (aria-disabled, not
// disabled) so a keyboard or screen reader user can find it and hear why
// it is not available yet.
const NavFooter = ({ showBack, onBack, showNext, nextLabel, nextLocked, busy, onNext, hint }) => (
  <Box component="nav" aria-label="Screen navigation" sx={{ mt: 3 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
      <Box>
        {showBack && (
          <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onBack}>
            Back
          </Button>
        )}
      </Box>
      {showNext && (
        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={nextLocked || busy ? undefined : onNext}
          aria-disabled={nextLocked || busy}
          aria-describedby="next-hint"
          disableRipple={nextLocked}
          sx={
            nextLocked
              ? {
                  bgcolor: '#E2E8F0',
                  color: colours.muted,
                  boxShadow: 'none',
                  cursor: 'not-allowed',
                  '&:hover': { bgcolor: '#E2E8F0', boxShadow: 'none' },
                }
              : undefined
          }
        >
          {busy ? 'Saving' : nextLabel}
        </Button>
      )}
    </Stack>
    <Typography
      id="next-hint"
      aria-live="polite"
      sx={{ mt: 1, minHeight: '1.6em', fontSize: '1rem', lineHeight: 1.6, color: colours.muted, textAlign: 'right' }}
    >
      {showNext ? hint : ''}
    </Typography>
  </Box>
)

export default NavFooter
